"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _storageKey, _emitter, _store, _timeouts;
Object.defineProperty(exports, "__esModule", { value: true });
const mitt_1 = __importDefault(require("mitt"));
const utility_1 = require("./utility");
const isExpirableKeyV0 = (entry) => {
    return entry.v === undefined && !!entry.key;
};
const isExpirableKeyV1 = (entry) => {
    return entry.v === 1 && !!entry.value;
};
const convertV0toV1 = (v0Entry) => ({
    v: 1,
    value: v0Entry.key,
    expiresAt: v0Entry.expiresAt
});
// --
class SessionKeystore {
    // --
    constructor(opts = {}) {
        _storageKey.set(this, void 0);
        _emitter.set(this, void 0);
        _store.set(this, void 0);
        _timeouts.set(this, void 0);
        this.name = opts.name || 'default';
        __classPrivateFieldSet(this, _storageKey, `session-keystore:${this.name}`);
        __classPrivateFieldSet(this, _emitter, mitt_1.default());
        __classPrivateFieldSet(this, _store, new Map());
        __classPrivateFieldSet(this, _timeouts, new Map()
        /* istanbul ignore else */
        );
        /* istanbul ignore else */
        if (typeof window !== 'undefined') {
            try {
                this._load();
            }
            catch (_a) { }
            window.addEventListener('unload', this.persist.bind(this));
        }
    }
    // Event Emitter --
    // Returns an unsubscribe callback
    on(event, callback) {
        __classPrivateFieldGet(this, _emitter).on(event, callback);
        return () => __classPrivateFieldGet(this, _emitter).off(event, callback);
    }
    off(event, callback) {
        __classPrivateFieldGet(this, _emitter).off(event, callback);
    }
    // API --
    set(key, value, expiresAt) {
        let d;
        if (expiresAt !== undefined) {
            d = typeof expiresAt === 'number' ? expiresAt : expiresAt.valueOf();
        }
        const newItem = {
            v: 1,
            value,
            expiresAt: d
        };
        const oldItem = __classPrivateFieldGet(this, _store).get(key);
        __classPrivateFieldGet(this, _store).set(key, newItem);
        if (this._setTimeout(key) === 'expired') {
            return; // Don't call created or updated
        }
        if (!oldItem) {
            __classPrivateFieldGet(this, _emitter).emit('created', { name: key });
        }
        else if (oldItem.value !== newItem.value) {
            __classPrivateFieldGet(this, _emitter).emit('updated', { name: key });
        }
    }
    get(key, now = Date.now()) {
        const item = __classPrivateFieldGet(this, _store).get(key);
        if (!item) {
            return null;
        }
        if (item.expiresAt !== undefined && item.expiresAt <= now) {
            this._expired(key);
            return null;
        }
        __classPrivateFieldGet(this, _emitter).emit('read', { name: key });
        return item.value;
    }
    delete(key) {
        this._clearTimeout(key);
        __classPrivateFieldGet(this, _store).delete(key);
        __classPrivateFieldGet(this, _emitter).emit('deleted', { name: key });
    }
    clear() {
        __classPrivateFieldGet(this, _store).forEach((_, key) => this.delete(key));
    }
    // --
    persist() {
        /* istanbul ignore next */
        if (typeof window === 'undefined') {
            throw new Error('SessionKeystore.persist is only available in the browser.');
        }
        const json = JSON.stringify(Array.from(__classPrivateFieldGet(this, _store).entries()));
        const [a, b] = utility_1.split(json);
        utility_1.saveToWindowName(__classPrivateFieldGet(this, _storageKey), a);
        window.sessionStorage.setItem(__classPrivateFieldGet(this, _storageKey), b);
    }
    _load() {
        const a = utility_1.loadFromWindowName(__classPrivateFieldGet(this, _storageKey));
        const b = window.sessionStorage.getItem(__classPrivateFieldGet(this, _storageKey));
        window.sessionStorage.removeItem(__classPrivateFieldGet(this, _storageKey));
        if (!a || !b) {
            return;
        }
        const json = utility_1.join(a, b);
        /* istanbul ignore next */
        if (!json) {
            return;
        }
        const entries = JSON.parse(json);
        __classPrivateFieldSet(this, _store, new Map(entries.map(([key, item]) => {
            if (isExpirableKeyV0(item)) {
                return [key, convertV0toV1(item)];
            }
            if (isExpirableKeyV1(item)) {
                return [key, item];
            }
            /* istanbul ignore next */
            return [key, item];
        }))
        // Re-establish timeouts
        );
        // Re-establish timeouts
        __classPrivateFieldGet(this, _store).forEach((_, key) => {
            this._setTimeout(key);
        });
    }
    _setTimeout(key) {
        this._clearTimeout(key);
        const keyEntry = __classPrivateFieldGet(this, _store).get(key);
        if ((keyEntry === null || keyEntry === void 0 ? void 0 : keyEntry.expiresAt) === undefined) {
            return;
        }
        const now = Date.now();
        const timeout = keyEntry.expiresAt - now;
        if (timeout <= 0) {
            this._expired(key);
            return 'expired';
        }
        const t = setTimeout(() => {
            this._expired(key);
        }, timeout);
        __classPrivateFieldGet(this, _timeouts).set(key, t);
        return undefined;
    }
    _clearTimeout(key) {
        const timeoutId = __classPrivateFieldGet(this, _timeouts).get(key);
        clearTimeout(timeoutId);
        __classPrivateFieldGet(this, _timeouts).delete(key);
    }
    _expired(key) {
        this._clearTimeout(key);
        __classPrivateFieldGet(this, _store).delete(key);
        __classPrivateFieldGet(this, _emitter).emit('expired', { name: key });
    }
}
exports.default = SessionKeystore;
_storageKey = new WeakMap(), _emitter = new WeakMap(), _store = new WeakMap(), _timeouts = new WeakMap();
